import { DataSourcesApi } from '@frontend/api-data-sources';
import { useQuery } from '@frontend/react-query-helpers';
import { getIsIntegratedOffice } from '../utils';

const CACHE_AND_STALE_TIME = 1000 * 60 * 5; // 5 minute

type UseGetIntegrationDetailsParamType = {
  selectedLocationId: string;
  parentLocationId?: string;
  enabled?: boolean;
};

export const useGetIntegrationDetails = ({
  selectedLocationId,
  parentLocationId = '',
  enabled = false,
}: UseGetIntegrationDetailsParamType) => {
  const integrationQueryDetails = useQuery({
    queryKey: ['integrations', parentLocationId, selectedLocationId],
    queryFn: async () => {
      const { SyncApps } = await DataSourcesApi.getAccessibleIntegrations(parentLocationId || selectedLocationId);
      return SyncApps || [];
    },
    enabled: !!selectedLocationId && enabled,
    staleTime: CACHE_AND_STALE_TIME, // 5 minute
    cacheTime: CACHE_AND_STALE_TIME, // 5 minute
  });

  const isIntegratedOffice = getIsIntegratedOffice(integrationQueryDetails?.data ?? []);

  return { isIntegratedOffice, ...integrationQueryDetails };
};
